export const lightTheme = {
  mode: "light",
  background: "#fff",
  body: "#f7fafc",
  text: "#000",
};
export const darkTheme = {
  mode: "dark",
  background: "#000",
  body: "#1d1d1f",
  text: "#fff",
};
